import React from "react"
import Img from "gatsby-image"
import { Badge } from "react-bootstrap"
import { useTranslation } from "../utils/language"

export default ({ html, frontmatter, image }) => {
  const { t } = useTranslation()
  const { company, position, startDate, endDate, location, tags } = frontmatter

  return (
    <div className="cv-timeline-item">
      <div className="cv-timeline-dot" />
      <div className="cv-timeline-content">
        <div className="cv-timeline-header">
          {image && (
            <div className="cv-timeline-logo">
              <Img fluid={image} alt={company} />
            </div>
          )}
          <div className="cv-timeline-meta">
            <h5 className="cv-timeline-company mb-0">
              {company}
              {position && (
                <span className="cv-timeline-position"> — {position}</span>
              )}
            </h5>
            <small className="card-meta-place">
              {location && <span>{location}</span>}
              {location && (startDate || endDate) && <span> · </span>}
              {startDate && <span>{startDate}</span>}
              {startDate && endDate && <span> → </span>}
              {endDate && <span>{endDate}</span>}
              {startDate && !endDate && <span> → {t("cv.present")}</span>}
            </small>
          </div>
        </div>

        {html && (
          <div
            className="cv-timeline-description"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        )}

        {tags && tags.length > 0 && (
          <div className="cv-timeline-tags">
            {tags.map(tag => (
              <Badge key={tag} pill className="mr-1 mb-1 badge-violet">
                {tag}
              </Badge>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
